import {
  AppstoreOutlined,
  BarChartOutlined,
  ContactsOutlined,
  DashboardOutlined,
  FileTextOutlined,
  HistoryOutlined,
  ImportOutlined,
  InboxOutlined,
  RollbackOutlined,
  SendOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import type { ReactNode } from 'react';

import type { UserRole } from '@/api/generated/model';
import { AuditPage } from '@/pages/audit/AuditPage';
import { ClientsSection } from '@/pages/catalog/ClientsPage';
import { ProductsPage } from '@/pages/catalog/ProductsPage';
import { ReturnReasonsPage } from '@/pages/catalog/ReturnReasonsPage';
import { ReceivingPage } from '@/pages/receiving/ReceivingPage';
import { ReportsPage } from '@/pages/reports/ReportsPage';
import { ShipmentsSection } from '@/pages/shipments/ShipmentsPage';
import { StockPage } from '@/pages/stock/StockPage';
import { SystemPage } from '@/pages/system/SystemPage';
import { UpdSection } from '@/pages/upd/UpdSection';
import { UsersPage } from '@/pages/users/UsersPage';

export interface Section {
  path: string;
  /** Ключ словаря (menu.*): название в меню на языке интерфейса. */
  labelKey: string;
  icon: ReactNode;
  /** Минимальная роль: меню прячет раздел, маршрут закрыт guard'ом. */
  minRole: UserRole;
  groupKey?: string;
  /** День плана (docs/ROADMAP.md), когда раздел появится; пока — заглушка. */
  plannedDay?: number;
  element?: ReactNode;
}

// Единый список разделов: из него строятся и меню, и маршруты.
export const SECTIONS: Section[] = [
  {
    path: '/shipments',
    labelKey: 'menu.shipments',
    icon: <SendOutlined />,
    minRole: 'storekeeper',
    element: <ShipmentsSection />,
  },
  {
    path: '/upd',
    labelKey: 'menu.upd',
    icon: <FileTextOutlined />,
    minRole: 'storekeeper',
    element: <UpdSection />,
  },
  {
    path: '/receiving',
    labelKey: 'menu.receiving',
    icon: <ImportOutlined />,
    minRole: 'storekeeper',
    element: <ReceivingPage />,
  },
  {
    path: '/stock',
    labelKey: 'menu.stock',
    icon: <InboxOutlined />,
    minRole: 'storekeeper',
    element: <StockPage />,
  },
  {
    path: '/catalog/products',
    labelKey: 'menu.products',
    icon: <AppstoreOutlined />,
    minRole: 'storekeeper',
    groupKey: 'menu.catalogs',
    element: <ProductsPage />,
  },
  {
    path: '/catalog/clients',
    labelKey: 'menu.clients',
    icon: <ContactsOutlined />,
    minRole: 'storekeeper',
    groupKey: 'menu.catalogs',
    element: <ClientsSection />,
  },
  {
    path: '/catalog/return-reasons',
    labelKey: 'menu.returnReasons',
    icon: <RollbackOutlined />,
    minRole: 'manager',
    groupKey: 'menu.catalogs',
    element: <ReturnReasonsPage />,
  },
  {
    path: '/reports',
    labelKey: 'menu.reports',
    icon: <BarChartOutlined />,
    minRole: 'manager',
    element: <ReportsPage />,
  },
  {
    path: '/system',
    labelKey: 'menu.system',
    icon: <DashboardOutlined />,
    minRole: 'manager',
    element: <SystemPage />,
  },
  {
    path: '/audit',
    labelKey: 'menu.audit',
    icon: <HistoryOutlined />,
    minRole: 'manager',
    element: <AuditPage />,
  },
  {
    path: '/users',
    labelKey: 'menu.users',
    icon: <TeamOutlined />,
    minRole: 'admin',
    element: <UsersPage />,
  },
];

/** Главная — сводка склада (DashboardPage), индексный маршрут «/». */
export const HOME = '/';
